import { render } from "./BoqQuotationBoqSummary.vue?vue&type=template&id=2e995b4a&scoped=true"
import script from "./BoqQuotationBoqSummary.vue?vue&type=script&lang=js"
export * from "./BoqQuotationBoqSummary.vue?vue&type=script&lang=js"

import "./BoqQuotationBoqSummary.vue?vue&type=style&index=0&id=2e995b4a&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e995b4a"]])

export default __exports__